import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'admin'

// const userInfo = JSON.parse(localStorage.getItem('userInfo'))
// const timeout = ms => new Promise(resolve => setTimeout(resolve, ms))

export default new AclCreate({
  initial  : initialRole,
  notfound : '/404',
  router,
  acceptLocalRules : true,
  globalRules: {
    admin  : new AclRule('admin').generate(),
    public : new AclRule('public').or('admin').generate()
  },
})
